import moment from 'moment';
import { reportField, reportNumber } from './reportFields';
import { buildReportsPath } from './reportPeriod';
import { buildSectionsNavPath } from './sectionNavViews';

export function isoDate(now = moment()) {
  return moment(now).format('YYYY-MM-DD');
}

export function todayRange(now = moment()) {
  const day = isoDate(now);
  return { from: day, to: day };
}

/** Inclusive last N days ending today — same pattern as reports `days30`. */
export function lastDaysRange(days, now = moment()) {
  const count = Number(days);
  const span = Number.isFinite(count) && count > 0 ? count : 1;
  const m = moment(now);
  return {
    from: m.clone().subtract(span - 1, 'days').format('YYYY-MM-DD'),
    to: m.format('YYYY-MM-DD'),
  };
}

export function formatPeriodCaption(from, to, now = moment()) {
  const today = isoDate(now);
  if (from === to && from === today) return 'Сегодня';
  const start = moment(from);
  const end = moment(to);
  if (!start.isValid() || !end.isValid()) return '';
  const a = start.format('DD.MM.YYYY');
  const b = end.format('DD.MM.YYYY');
  return a === b ? a : `${a} — ${b}`;
}

export function formatCurrencyRub(value) {
  const numValue = typeof value === 'number' && !Number.isNaN(value) ? value : (parseFloat(value) || 0);
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: 0,
  }).format(numValue);
}

export function formatPercent(value) {
  const n = typeof value === 'number' ? value : parseFloat(value);
  return `${Number.isFinite(n) ? n : 0}%`;
}

export function centerSearch(centerId) {
  if (!centerId) return '';
  return `?centerId=${encodeURIComponent(String(centerId))}`;
}

export function buildOperatorHomeCards({
  todaySummary,
  weekSummary,
  centerId,
  today,
  week,
  now = moment(),
}) {
  const lifecycle = reportField(todaySummary, 'Lifecycle', 'lifecycle', {}) || {};
  const search = centerSearch(centerId);

  return [
    {
      key: 'requests',
      label: 'Заявки',
      period: formatPeriodCaption(today.from, today.to, now),
      value: String(reportNumber(lifecycle, 'RequestCount', 'requestCount')),
      to: buildSectionsNavPath('requests', search),
    },
    {
      key: 'occupancy',
      label: 'Загрузка зала',
      period: formatPeriodCaption(today.from, today.to, now),
      value: formatPercent(reportNumber(todaySummary, 'OccupancyHallPercent', 'occupancyHallPercent')),
      to: buildReportsPath({
        centerId,
        from: today.from,
        to: today.to,
        tab: 'occupancy',
      }),
    },
    {
      key: 'receivable',
      label: 'К получению',
      period: formatPeriodCaption(week.from, week.to, now),
      value: formatCurrencyRub(reportNumber(weekSummary, 'Receivable', 'receivable')),
      to: buildReportsPath({
        centerId,
        from: week.from,
        to: week.to,
        tab: 'receivables',
      }),
    },
    {
      key: 'expiring',
      label: 'Истекает',
      period: formatPeriodCaption(today.from, today.to, now),
      value: String(reportNumber(lifecycle, 'ExpiringAbonementCount', 'expiringAbonementCount')),
      to: buildSectionsNavPath('abonements', search),
    },
  ];
}
